// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"db314340","455":"da4712b9","977":"86b88af7"}[chunkId] + ".chunk.js";
};